import '@/styles/storefront.css'
import 'font-awesome/css/font-awesome.min.css'
import { onBeforeUnmount, onMounted } from 'vue'

let refCount = 0

function installStorefrontTheme() {
  document.body.classList.add('fusion-body', 'mmg-storefront-active')
  document.documentElement.classList.add('mmg-storefront-active')
}

function uninstallStorefrontTheme() {
  document.body.classList.remove('fusion-body', 'mmg-storefront-active')
  document.documentElement.classList.remove('mmg-storefront-active')
}

/** 前台页面：仅挂载 body 类名，样式见 src/styles/storefront.css（无外链 CSS） */
export function useStorefrontTheme() {
  onMounted(() => {
    if (refCount === 0) installStorefrontTheme()
    refCount += 1
  })

  onBeforeUnmount(() => {
    refCount -= 1
    if (refCount <= 0) {
      refCount = 0
      uninstallStorefrontTheme()
    }
  })
}
